export const statusColors = {
  ACTIVE: 'bg-green-500/20 text-green-400',
  INACTIVE: 'bg-gray-500/20 text-gray-400',
  SOLD: 'bg-blue-500/20 text-blue-400',
  SCRAPPED: 'bg-red-500/20 text-red-400',
  STOLEN: 'bg-red-600/20 text-red-500',
  MAINTENANCE: 'bg-amber-500/20 text-amber-400',
  DELETED: 'bg-gray-500/20 text-gray-500',
}

export const STATUS_OPTIONS = ['ACTIVE', 'INACTIVE', 'SOLD', 'SCRAPPED', 'STOLEN', 'MAINTENANCE']
export const FUEL_OPTIONS = ['PETROL', 'DIESEL', 'ELECTRIC', 'HYBRID', 'HYBRID_DIESEL', 'PLUG_IN_HYBRID', 'LPG', 'CNG', 'OTHER']

export const OWNERSHIP_OPTIONS = ['OWNER', 'FAMILY_MEMBER', 'SHARED_USER', 'VIEWER', 'MECHANIC', 'INSURANCE_AGENT']

export const ownershipColors = {
  OWNER: 'bg-blue-500/20 text-blue-400',
  FAMILY_MEMBER: 'bg-purple-500/20 text-purple-400',
  SHARED_USER: 'bg-cyan-500/20 text-cyan-400',
  VIEWER: 'bg-gray-500/20 text-gray-400',
  MECHANIC: 'bg-amber-500/20 text-amber-400',
  INSURANCE_AGENT: 'bg-green-500/20 text-green-400',
}

export const DEFAULT_PAGE_SIZE = 20
